"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsComposingHandler = void 0;
var _react = require("react");
/**
 * When an IME is used to input text, events fired will have isComposing set to true. When this is
 * the case, we do not want to allow Enter or Escape to be handled by the onKeyDown handler.
 * Generally though, we shouldn't handle ANY keydown events when isComposing is true so this utility
 * helps us block them when necessary.
 *
 * You should wrap your onKeyDown handlers for input fields with this function to ensure that it is
 * not called when isComposing is true.
 *
 * 1) the returned function is wrapped in useCallback for memoization if necessary.
 * 2) the keydown event handler will not be called if isComposing is true.
 *
 * Example:
 *
 * ```
 *  const handleKeyEvent = useIsComposingHandler((e) => {
 *      switch (e.key) {
 *          case "Enter": {
 *              setSubmittedValue(value);
 *          }
 *      }
 *  });
 *
 *  return (
 *      <input onKeyDown={onKeyDown} />
 *  )
 * ```
 *
 * If necessary, wrap your own handler in useCallback to ensure memoization of the resulting
 * function:
 *
 * ```
 *  const handleKeyEvent = useIsComposingHandler(useCallback((e) => {
 *      switch (e.key) {
 *          case "Enter": {
 *              setSubmittedValue(value);
 *          }
 *      }
 *  }, []));
 * ```
 */
const useIsComposingHandler = handler => {
  return (0, _react.useCallback)(e => {
    if (e.nativeEvent.isComposing) {
      return;
    } else {
      handler(e);
    }
  }, [handler]);
};
exports.useIsComposingHandler = useIsComposingHandler;
//# sourceMappingURL=useIsComposingHandler.js.map